import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children
}) => {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <LoadingSpinner data-id="element-628" />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-629" />;
  }
  return <>{children}</>;
};
export default ProtectedRoute;